import { Injectable } from '@angular/core';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ProjectVO } from '@project/model/vo/project.vo';
import { Observable } from 'rxjs';

type CustomDataSheetRequest = {
  project: ProjectVO,
  boundingBox: { min: number[], max: number[] },
  localeKey: string,
  projectLink: string | null,
  articleId: number | undefined,
}

@Injectable({
  providedIn: 'root'
})
export class DataSheetDataService {
  constructor(
    private wagoApiClient: WagoApiClient,
  ) {
  }

  public request(project: ProjectVO,
                 boundingBox: { min: number [], max: number[] },
                 projectLink: string | null,
                 localeKey: string,
                 articleId:number | undefined,
  ): Observable<{ link: string }> {
    const requestUrl = `datasheet/custom`;
    const request: CustomDataSheetRequest = {project, boundingBox, localeKey, projectLink, articleId};
    return this.wagoApiClient.post<{ link: string }>(
      requestUrl,
      request,
      null,
      {overlayType: null, isErrorHandlingRequired: false},
    );
  }
}
